import {arrowLeftCircleSvg as Icon__small__arrowLeftCircleSvg} from '../Icon__small/Icon__small--arrowLeftCircle.js';

export var arrowLeftCircle = {
  name: 'arrowLeftCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowLeftCircleSvg,
};
